import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT_SUCCESS,
  USER_REFRESH_TOKEN_FAIL,
  USER_REFRESH_TOKEN_REQUEST,
  USER_REFRESH_TOKEN_SUCCESS,
} from "../ActionType/loginTypes";

export const userLoginReducer = (
  state = { loading: false, isLoggedIn: false, userInfo: [], error: "" },
  action
) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return {
        loading: true,
      };
    case USER_LOGIN_SUCCESS:
      return {
        loading: false,
        isLoggedIn: true,
        userInfo: action.payload,
        error: "",
      };
    case USER_LOGOUT_SUCCESS:
      return {
        isLoggedIn: false,
        userInfo: [],
      };
    case USER_LOGIN_FAIL:
      return {
        loading: false,
        isLoggedIn: false,
        userInfo: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const userRefreshTokenReducer = (
  state = { loading: true, userInfo: [], error: "" },
  action
) => {
  switch (action.type) {
    case USER_REFRESH_TOKEN_REQUEST:
      return {
        loading: true,
      };
    case USER_REFRESH_TOKEN_SUCCESS:
      return {
        loading: false,

        userInfo: action.payload,
        error: "",
      };
    case USER_REFRESH_TOKEN_FAIL:
      return {
        loading: false,

        userInfo: [],
        error: "Check Your Request",
      };
    default:
      return state;
  }
};
